import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
export const InputStyles = styled.div.withConfig({
  displayName: "TextInputstyles__InputStyles",
  componentId: "sc-5kcv37-0"
})(["display:inline-block;position:relative;vertical-align:left;border-color:white !important;background-color:white !important;width:100%;input{padding-top:14px !important;padding-bottom:18px !important;", " ", "}.Country,input,.CompanyDomainDropdown{", " border:2px solid;border-left:none !important;border-right:none !important;border-top:none !important;", " ", " ", "}.Country,.CompanyDomainDropdown{margin-bottom:20px;}div[data-selenium-id='country']:hover{box-shadow:none !important;background:white;}div[aria-expanded='true']{", "}input[aria-invalid='true']{border-bottom-color:#bf2434 !important;}input:focus{", "}input[aria-invalid='true'],input[aria-invalid='true']:focus{box-shadow:none !important;}"], props => props.industryStyle && `
      margin-bottom: -3px;
    `, props => props.inputFontSize && `
      font-size: ${props.inputFontSize}px;
    `, props => `
      border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;
    `, props => props.success && `
      border-bottom-color: ${props.theme.color['fill-accent-green-hover']} !important;
    `, props => props.error && `
      border-bottom-color: #bf2434 !important;
    `, props => props.disabled && `
      background-color: ${props.theme.color['fill-accent-neutral-subtle-alt']} !important;
      box-shadow: none !important;
      border-bottom-color: #cbd6e2 !important;
    `, props => `
      border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;
    `, props => props.industryStyle && `
        border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;
        ${props.success && `
          border-bottom-color: ${props.theme.color['fill-accent-green-hover']} !important;
        `}
        ${props.error && `
          border-bottom-color: #bf2434 !important;
        `}
      `);

/**
 * This component is adapted to not rely on the style overrides from typeahead.scss which
 * modify UIComponents internal classnames.
 *
 * Long-term this component will replace the InputStyles component once all occurrences of
 * InputStyles are removed from the codebase.
 */
export const MigratedInputStyles = styled(InputStyles).withConfig({
  displayName: "TextInputstyles__MigratedInputStyles",
  componentId: "sc-5kcv37-1"
})(["input{border:1px solid #fff;background-color:#fff;text-align:left;font-size:22px;padding-left:0px;border-radius:0px;", " &:focus{border-color:#fff;box-shadow:none;}&:hover{border-color:#fff;box-shadow:none;}&:disabled{background-color:#fff;border:1px solid #fff;}}.Country,input,.CompanyDomainDropdown{border-bottom-color:", " !important;border:2px solid;border-left:none !important;border-right:none !important;border-top:none !important;", " ", " ", "}"], props => props.inputFontSize && `
      font-size: ${props.inputFontSize}px;
    `, props => props.theme.color['border-info-default'], props => props.success && `
      border-bottom-color: ${props.theme.color['border-positive-default']} !important;
    `, props => props.error && `
      border-bottom-color: #bf2434 !important;
    `, props => props.disabled && `
      background-color: ${props.theme.color['fill-field-disabled']} !important;
      box-shadow: none !important;
      border-bottom-color: #cbd6e2 !important;
    `);
export const StyledUILink = styled(UILink).withConfig({
  displayName: "TextInputstyles__StyledUILink",
  componentId: "sc-5kcv37-2"
})(["color:#0b8484;"]);
export const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "TextInputstyles__StyledFormattedMessage",
  componentId: "sc-5kcv37-3"
})(["color:#0b8484 !important;"]);